import { createFileRoute } from '@tanstack/react-router'

import { ResourcesIndexPage } from '../../components/pages/resources/resources-index-page.tsx'

export const Route = createFileRoute('/resources/')({
  component: ResourcesIndexPage,
})
